// extracted by mini-css-extract-plugin
module.exports = {"page":"OrderConfirmsPage_page__1aQeZ","tabs":"OrderConfirmsPage_tabs__2UNtx"};